import { tenantBillingControllerGetStatus } from '@/generated/korza-api-client';
import type { TenantBillingStatusResponseDto } from '@/generated/korza-api-client/types.gen';
import { useQuery } from '@tanstack/react-query';
import { useTenantNullable } from '@/hooks/use-tenant';

export function billingStatusQueryKey(tenantSlug: string) {
  return ['billing-status', tenantSlug] as const;
}

export function useBillingStatus() {
  const tenant = useTenantNullable();

  return useQuery<TenantBillingStatusResponseDto>({
    queryKey: billingStatusQueryKey(tenant?.slug ?? ''),
    queryFn: async () => {
      if (!tenant?.slug) {
        throw new Error('Tenant slug is required');
      }

      const result = await tenantBillingControllerGetStatus({
        path: { tenantSlug: tenant.slug },
        throwOnError: true,
      });

      if (!result.data) {
        throw new Error('Failed to load billing status');
      }

      return result.data;
    },
    enabled: !!tenant?.slug,
  });
}
